import React from "react";
import NavBar from "../NavBar";

const General = () => {
  return (
    <div>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Settings </span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div className="dashborad_title">
        <h1>General</h1>
      </div>
    </div>
  );
};

export default General;
